import api from "../config/api";

export const sendMessage = async(postData) => {
    const res = await api.post('/message/', postData);
    console.log(res);
    
    return res.data;
}